// @flow
import React, { Fragment } from 'react';
import type { Categories } from 'store/modules/products';
import { IconContext } from 'react-icons';
import { Link } from 'react-router-dom';
import { AiOutlineRight } from 'react-icons/ai';
import { escapeForUrl } from 'lib/common';
import './ProductCategories.scss';

type Props = {
  categories: Categories,
};

const ProductCategories = ({ categories }: Props) => {
  const firstSortedCategories = categories
    .filter(category => category.order === 1)
    .sort((a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0));
  const secondSortedCategories = categories
    .filter(category => category.order === 2)
    .sort((a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0));
  const thirdCategories = categories.filter(category => category.order === 3);

  // 대, 중 카테고리는 알파벳순으로 정렬
  // 소 카테고리는 단순 알파벳 순으로 정렬하면 안되고 parent 정보 활용해서 정렬
  let thirdSortedCategories = [];

  for (let i = 0; i < secondSortedCategories.length; i += 1) {
    for (let j = 0; j < thirdCategories.length; j += 1) {
      if (secondSortedCategories[i].id === thirdCategories[j].parent) {
        thirdSortedCategories.push(thirdCategories[j]);
      }
    }
  }

  return (
    <div className="ProductCategories">
      <nav>
        <ol>
          <li className="category-items">
            {firstSortedCategories.map((category, index) => (
              <Fragment key={category.id}>
                {index === 1 && <span style={{ margin: '0 4px' }}>,</span>}
                <Link to={`/categories#${category.url_slug}`}>{category.name}</Link>
              </Fragment>
            ))}
            {!!secondSortedCategories.length && (
              <IconContext.Provider value={{ color: '#868e96', size: '11px' }}>
                <span style={{ margin: '0 4px' }}>
                  <AiOutlineRight />
                </span>
              </IconContext.Provider>
            )}
          </li>
          <li className="category-items">
            {secondSortedCategories.map((category, index) => (
              <Fragment key={category.id}>
                {index === 1 && <span style={{ margin: '0 4px' }}>,</span>}
                <Link to={`/categories/${escapeForUrl(category.url_slug)}`}>{category.name}</Link>
              </Fragment>
            ))}
            {!!thirdSortedCategories.length && (
              <IconContext.Provider value={{ color: '#868e96', size: '11px' }}>
                <span style={{ margin: '0 4px' }}>
                  <AiOutlineRight />
                </span>
              </IconContext.Provider>
            )}
          </li>
          <li className="category-items">
            {thirdSortedCategories.map((category, index) => (
              <Fragment key={category.id}>
                {index === 1 && <span style={{ margin: '0 4px' }}>,</span>}
                <Link to={`/categories/${escapeForUrl(category.url_slug)}`}>{category.name}</Link>
              </Fragment>
            ))}
          </li>
        </ol>
      </nav>
    </div>
  );
};

ProductCategories.Placeholder = () => (
  <div className="ProductCategories placeholder">
    <div className="firstCategory gray-block" />
    <IconContext.Provider value={{ color: '#f1f3f5', size: '12px' }}>
      <div className="right-arrow">
        <AiOutlineRight />
      </div>
    </IconContext.Provider>
    <div className="secondCategory gray-block" />
    <IconContext.Provider value={{ color: '#f1f3f5', size: '12px' }}>
      <div className="right-arrow">
        <AiOutlineRight />
      </div>
    </IconContext.Provider>
    <div className="thirdCategory gray-block" />
  </div>
);

export default ProductCategories;



// WEBPACK FOOTER //
// ./src/components/product/ProductCategories/ProductCategories.js